
            import Icon from 'veui/components/Icon';
            Icon.register({"play":{"raw":"<title>&#x64AD;&#x653E;</title><path d=\"M7 13A6 6 0 1 0 7 1a6 6 0 0 0 0 12zm0 1A7 7 0 1 1 7 0a7 7 0 0 1 0 14zM6 4v6l4-2.929L6 4z\" fill-rule=\"nonzero\" fill=\"currentColor\"/>","width":14,"height":14}});

        